import React from "react";
import { Row, Col, Card } from "antd";
import { Link } from "react-router-dom";
import holiday from "@assets/imgs/holiday.jpg";
import consulting from "@assets/imgs/consulting.jpg";
import spaces from "@assets/imgs/spaces.jpg";
import meeting from "@assets/imgs/meeting.jpg";
import classes from "@assets/imgs/classes.jpg";
import events from "@assets/imgs/events.jpg";

const UserServicesList = () => {
  const style = {
    card: {
      width: 240,
      height: 260,
      display: "block",
      margin: "auto",
    },
    title: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "15px",
    },
  };
  return (
    <div style={{ paddingBottom: 40 }}>
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 50]}
        justify="center"
        align="middle"
      >
        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/work-spaces">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={spaces} />}
            >
              <p style={style.title}>فضای کار</p>
            </Card>
          </Link>
        </Col>

        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/meeting-rooms">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={meeting} />}
            >
              <p style={style.title}>اتاق جلسات</p>
            </Card>
          </Link>
        </Col>

        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/classes">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={classes} />}
            >
              <p style={style.title}>دوره‌های آموزشی</p>
            </Card>
          </Link>
        </Col>

        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/events">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={events} />}
            >
              <p style={style.title}>رویدادها</p>
            </Card>
          </Link>
        </Col>

        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/consulting">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={consulting} />}
            >
              <p style={style.title}>مشاوره</p>
            </Card>
          </Link>
        </Col>

        <Col xl={6} lg={8} sm={12} xs={24}>
          <Link to="/services/holiday">
            <Card
              hoverable
              style={style.card}
              cover={<img alt="safatec" src={holiday} />}
            >
              <p style={style.title}>روزهای تعطیل</p>
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default UserServicesList;
